import { IsEmptyExpression } from "../../../Models/Comparators/IsEmptyExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class IsEmptyExpressionEvaluator implements IExpressionEvaluator<IsEmptyExpression>, IHasExpressionMetadata {
    get type(): string {
        return "IsEmpty";
    }

    private static _expressionPropertyNames: string[] = ["Value"];

    get expressionProperties(): string[] {
        return IsEmptyExpressionEvaluator._expressionPropertyNames;
    }

    evaluate(expression: IsEmptyExpression, context: IExpressionEvaluatorContext): MaybePromise {
        if (!expression.Value) {
            return false;
        }

        // To evaluate the inner expression
        const value = context.Evaluator.evaluate(expression.Value, context);
        if (value instanceof Promise) {
            return value.then((resolvedValue) => this.isEmpty(resolvedValue));
        }
        return this.isEmpty(value);
    }

    private isEmpty(value: any): boolean {
        if (value == null || value === undefined) {
            return true;
        }
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        if (typeof value === "object") {
            return Object.keys(value).length === 0;
        }
        if (typeof value === "string") {
            return value.length === 0;
        }
        return false;
    }
}
